<dx-popup
  [showTitle]="true"
  [title]="dialogTitle"
  [dragEnabled]="false"
  [closeOnOutsideClick]="false"
  [showCloseButton]="true"
  [fullScreen]="true"
  (onHiding)="closeDialog()"
  [(visible)]="openDialog"
>
  <form>
    <div class="row mg-t-10">
      <div class="col-md-12">
        <i class="pi pi-info-circle"></i> Chaque point de livraison client sélectionné sera associé au modèle de conditionnement point de livraison actuel. <br/>
        Les points de livraison client qui ont déjà été configurés avec un modèle de conditionnement point de livraison ne seront pas proposés à l'écran.
      </div>
    </div>
    <div class="row mg-t-10">
        <div class="col-lg-3">
          <dx-tag-box
            placeholder="Filtrer les points de livraison par libellé client..."
            (onValueChanged)="onChangeClientFilter($event)"
            [dataSource]="allClients"
            [showSelectionControls]="true"
            displayExpr="libelle"
            valueExpr="id"
            [searchEnabled]="true"
            applyValueMode="instantly">
          </dx-tag-box>
        </div>
      <div class="col-lg-3">
        <dx-tag-box
          placeholder="Filtrer les points de livraison par site..."
          (onValueChanged)="onChangeSiteFilter($event)"
          [dataSource]="sitesUtilisateurConnecte"
          [showSelectionControls]="true"
          displayExpr="libelle"
          valueExpr="id"
          [searchEnabled]="true"
          applyValueMode="instantly">
        </dx-tag-box>
      </div>
      <div class="col-lg-3">
        <dx-tag-box
          placeholder="Filtrer les points de livraison par libellé..."
          (onValueChanged)="onChangePlcsFilter($event)"
          [dataSource]="allPlcs"
          [showSelectionControls]="true"
          displayExpr="libelle"
          valueExpr="id"
          [searchEnabled]="true"
          applyValueMode="instantly">
        </dx-tag-box>
      </div>
      <div class="col-lg-3">
        <dx-tag-box
          placeholder="Filtrer les points de livraison par code client..."
          (onValueChanged)="onChangeClientCodeFilter($event)"
          [dataSource]="allClients"
          [showSelectionControls]="true"
          displayExpr="code"
          valueExpr="id"
          [searchEnabled]="true"
          applyValueMode="instantly">
        </dx-tag-box>
      </div>
    </div>
    <div class="row mg-t-10">
      <div class="col-md-4">
        <dx-tag-box
          placeholder="Filtrer les points de livraison par code..."
          (onValueChanged)="onChangeCodeFilter($event)"
          [dataSource]="allPlcs"
          [showSelectionControls]="true"
          displayExpr="code"
          valueExpr="id"
          [searchEnabled]="true"
          applyValueMode="instantly">
        </dx-tag-box>
      </div>
      <div class="col-md-4">
        <dx-tag-box
          placeholder="Filtrer les points de livraison par offre alimentaire..."
          (onValueChanged)="onChangeOffreAlimentaireFilter($event)"
          [dataSource]="allOffres"
          [showSelectionControls]="true"
          displayExpr="libelle"
          valueExpr="id"
          [searchEnabled]="true"
          applyValueMode="instantly">
        </dx-tag-box>
      </div>
      <div class="col-md-4">
        <dx-tag-box
          placeholder="Filtrer les points de livraison par prestation..."
          (onValueChanged)="onChangePrestationFilter($event)"
          [dataSource]="allPrestations"
          [showSelectionControls]="true"
          displayExpr="libelle"
          valueExpr="id"
          [searchEnabled]="true"
          applyValueMode="instantly">
        </dx-tag-box>
      </div>
    </div>
    <div class="row mg-t-10">
      <div class="col-md-12">
        <div class="p-inputgroup input-group-sm ">
          <dx-data-grid
            [dataSource]="dataSource"
            keyExpr="id"
            [height]="600"
            [hoverStateEnabled]="true"
            [rowAlternationEnabled]="true"
            [allowColumnResizing]="true"
            [showRowLines]="true"
            [showBorders]="true"
            [remoteOperations]="true"
            (onSelectionChanged)="checkDisabledButtons()"
            (onCellClick)="cellClick($event)"
            #gridPlcsToAdd>

            <dxo-selection [deferred]="true" [allowSelectAll]="true" [showCheckBoxesMode]="checkBoxesMode" mode="multiple"></dxo-selection>

            <dxi-column dataField="libelleSite" caption="Site" cellTemplate="siteCellTemplate" [allowFiltering]="false"></dxi-column>
            <dxi-column dataField="libelleClient" caption="Client" [allowFiltering]="false"></dxi-column>
            <dxi-column dataField="libelle" caption="Point de livraison client" [allowFiltering]="false"></dxi-column>
            <dxi-column dataField="offreAlimentaire.libelle" caption="Offre alimentaire" [allowFiltering]="false"></dxi-column>
            <dxi-column dataField="prestation.libelle" caption="Prestation" [allowFiltering]="false"></dxi-column>

            <div *dxTemplate="let cell of 'siteCellTemplate'">
              <yo-site [siteId]="convertNumber(cell.row.data.idSite)" [siteLibelle]="cell.row.data.libelleSite"
                       [yoDelayMsTooltip]="1500"></yo-site>
            </div>

            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-paging [pageSize]="50"></dxo-paging>

            <dxo-pager
              [showPageSizeSelector]="true"
              [allowedPageSizes]="[20, 50, 100]"
              [showNavigationButtons]="false"
              [visible]="true"
              [showInfo]="true"
              infoText="{2} point(s) de livraison client">
            </dxo-pager>

          </dx-data-grid>

        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end" style="margin-top: 15px">
      <yo-button
        iconClass="fas fa-plus"
        label="Ajouter"
        (onClick)="save()"
        [disabled]="!canSave()">
      </yo-button>
      <yo-button
        class="mg-l-5"
        buttonClass="cta-delete"
        (onClick)="closeDialog()"
        iconClass="fas fa-times"
      >
      </yo-button>
    </div>
  </form>
</dx-popup>
